export default __webpack_public_path__ + "static/around3-6e63280dc02844d9c5f948a563af3d29.png";